<template>
  <main id="container" class="page-container">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="이벤트" />
        </div>
      </div>
    </div>
    <div class="page-content event-check event-purchase">
      <div class="container">
        <div class="page-sub-header">
          <h3 class="page-sub-title">
            <span class="prima">동행축제 이벤트에 참여하고</span> 푸짐한 선물
            받으세요.
          </h3>
        </div>
      </div>
      <div class="page-tab-container">
        <div class="container tab-buttons">
          <router-link to="purchase" class="tab-button is-active"
            >소비인증 캠페인</router-link
          >
          <router-link to="store" class="tab-button"
            >코그페 스토어 인증</router-link
          >
        </div>
      </div>
      <div class="container">
        <div class="event-check-container">
          <div class="event-check-header">
            <div class="event-check-header-img">
              <div class="banner-img">
                <picture>
                  <source
                    media="(max-width: 767px)"
                    srcset="@/assets/img/event/img-event-m-tab-02.png"
                  />
                  <img src="@/assets/img/event/img-event-tab-02.png" />
                </picture>
              </div>
            </div>
            <div class="event-check-header-info">
              <ul class="event-check-header-info-list">
                <li v-for="(item, idx) in infoList" :key="idx">
                  <span class="infolist-title relayBadge">{{
                    item.title
                  }}</span>
                  <span class="infolist-text">{{ item.detail }}</span>
                </li>
                <li
                  style="
                    display: flex;
                    align-items: flex-start;
                    list-style: none;
                  "
                >
                  <span class="infolist-title relayBadge">{{
                    "진행방식"
                  }}</span>

                  <span class="infolist-text"
                    >동네가게·전통시장·소상공인 매장 등에서 소비 후, 소비 현장
                    사진 또는 코리아 그랜드 페스티벌 공식 포스터를 SNS에
                    게시하고, 해당 게시물을 코리아 그랜드 페스티벌 인스타그램
                    DM으로 제출
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="event-check-guide">
            <span class="event-check-guide-title">참여방법</span>
            <div class="event-check-guide-desc no-border">
              <ul class="event-check-guide-desclist">
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img">
                    <img src="@/assets/img/event/img-relay-step1.svg" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 1</span>
                    <span class="desclist-text"
                      >10월21일 ~ 11월15일 기간 동네가게·전통시장·소상공인 매장
                      등에서 소비(온라인쇼핑도 가능)</span
                    >
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img">
                    <img src="@/assets/img/event/img-relay-step2.svg" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 2</span>
                    <div class="desclist-text">
                      소비 현장 사진 또는 ‘코리아 그랜드 페스티벌’ 공식 포스터를
                      개인(기관) SNS에 게시
                      <br />
                      <span>
                        * 해시태그 필수 : #코리아그랜드페스티벌 #소비인증
                      </span>
                      <br />
                      <span>
                        * 팔로우 필수 : ‘코리아 그랜드 페스티벌’ 인스타그램
                      </span>
                    </div>
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img">
                    <img src="@/assets/img/event/img-relay-step3.svg" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 3</span>
                    <span class="desclist-text"
                      >해당 게시물 링크와 소비 영수증을 ‘코리아 그랜드 페스티벌’
                      인스타그램 DM으로 제출</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="event-check-products">
            <span class="event-check-products-title">경품소개</span>
            <ul class="relaryPrizesWrap">
              <li>
                <div class="prizesImg">
                  <img
                    src="@/assets/img/event/onnuriVoucher.png"
                    alt="온누리 상품권 이미지"
                  />
                </div>
                <div class="prizesInfo">
                  <p>디지털 온누리 상품권</p>
                  <p>100만원 3명</p>
                </div>
              </li>
              <li>
                <div class="prizesImg">
                  <img
                    src="@/assets/img/event/onnuriVoucher.png"
                    alt="온누리 상품권 이미지"
                  />
                </div>
                <div class="prizesInfo">
                  <p>디지털 온누리 상품권</p>
                  <p>10만원 10명</p>
                </div>
              </li>
              <li>
                <div class="prizesImg">
                  <img
                    src="@/assets/img/event/onnuriVoucher.png"
                    alt="온누리 상품권 이미지"
                  />
                </div>
                <div class="prizesInfo">
                  <p>디지털 온누리 상품권</p>
                  <p>5만원 30명</p>
                </div>
              </li>
              <li>
                <div class="prizesImg">
                  <img
                    src="@/assets/img/event/onnuriVoucher.png"
                    alt="온누리 상품권 이미지"
                  />
                </div>
                <div class="prizesInfo">
                  <p>디지털 온누리 상품권</p>
                  <p>1만원 460명</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="event-check-button-box">
        <div class="container flex-column">
          <span class="event-check-prect-title">경품발송</span>
          <ul class="event-check-prect-list">
            <li
              class="event-check-prect-list-li"
              v-for="(item, idx) in deliveryList"
              :key="idx"
            >
              <span class="prect-list-text" v-html="item"></span>
            </li>
          </ul>
        </div>
      </div>

      <div class="into-area">
        <button
          type="button"
          v-if="isShowBtn"
          class="event-check-button"
          @click="clickLink('https://naver.me/59vrLIbU')"
        >
          참여하기
        </button>
        <!-- <span class="into-button"><a href="https://naver.me/5bV9JGrN" target="_blank">참여하기</a></span> -->
      </div>

      <div class="event-check-prect">
        <div class="container">
          <span class="event-check-prect-title">유의사항</span>
          <ul class="event-check-prect-list">
            <li
              class="event-check-prect-list-li"
              v-for="(item, idx) in prectList"
              :key="idx"
            >
              <div class="prect-list-text" v-html="item"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
.accept-button a {
  width: 80px; /* 버튼 너비 유지 */
  height: 25px; /* 버튼 높이 유지 */
  border-radius: 7px;
  display: inline-flex;
  background-color: #e7dc37;
  color: #000000;
  font-size: 17px;
  font-weight: 400;
  justify-content: center;
  align-items: center;
}
.into-area {
  text-align: center;
}
.into-button a {
  display: inline-flex;
  padding: 6px 12px;
  background-color: #f5e50e;
  border-radius: 16px;
  color: #ffffff;
  font-size: 25px;
  font-weight: 700;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.my-table {
  border-collapse: collapse; /* 셀 간 간격 제거 */
  width: 100%; /* 테이블 너비 설정 (선택 사항) */
  overflow: hidden; /* border-radius가 잘리는 것 방지 */
  margin-top: 30px;
  width: 52%; /* 표 너비 설정 */
}

.my-table th,
.my-table td {
  border: 1px solid #ebebeb; /* 테두리 추가 */
  padding: 8px; /* 셀 안쪽 여백 */
  text-align: center; /* 텍스트 가운데 정렬 */
  width: 200px;
}

.my-table th {
  background-color: #ffffff; /* 제목 셀 배경색 */
}
.my-table span {
  font-weight: bold;
}

.prect-list-text {
  display: block;
  width: calc(100% - 30px);
}
.prect-list-text a {
  word-break: break-all; /* Break words at any character */
  overflow-wrap: break-word; /* Allow long words to be broken */
  display: inline;
}
.prect-list-text ::v-deep a.appstore-link {
  font-size: 19px; /* 원하는 폰트 사이즈로 조절 */
  color: red;
}
.prect-list-text ::v-deep .info-color {
  color: red;
}
</style>

<script>
import PageHeader from "@/components/content/PageHeader";
export default {
  name: "EventPurchase",
  components: { PageHeader },
  data: () => ({
    visibleModal: false,
    infoList: [
      {
        title: "참여기간",
        detail: "2026년 10월 21일(수) ~ 11월 15일(일)",
      },
      {
        title: "결과발표",
        detail: "2026년 12월 중",
      },
      {
        title: "경품발송",
        detail: "2027년 1월 중",
      },
    ],
    deliveryList: [
      "당첨자 발표 후, DM으로 개별 연락하여 당첨자 핸드폰번호로 쿠폰 전송",
      "5만원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부안내 및 개인정보 및 고유식별정보 수집·이용 및 제공 동의 필요",
    ],

    prectList: [
      "본 이벤트는 해당 기간(10.21.~11.15.) 내동네가게·전통시장·소상공인 매장 등에서 소비 후, 소비현장 사진 또는 코리아 그랜드 페스티벌 공식 포스터를SNS에 게시하고, 해당 게시물을 코리아 그랜드 페스티벌 인스타그램 DM으로 제출하면 응모가 완료됩니다.",
      "SNS 게시물에는 소비 현장 사진 또는 코리아 그랜드 페스티벌 공식 포스터와 지정된 필수 해시태그, 코그페 인스타그램 팔로우가 모두 포함되어야 합니다.",
      "해당 게시물 링크와 소비 사실을 확인할 수 있는 영수증을 코그페 인스타그램 DM으로 제출해야 합니다.",
      "이벤트 검수 및 당첨자 선정 시 참여내역을 확인할 수 있도록 당첨자 발표 시점까지 해당 SNS 게시물과 코그페 팔로우를 유지해야 합니다.",
      "중복 접수 시 미션 기준에 충족하는 1건만 인정 처리 됩니다.",
      "이벤트 응모를 위해 수집된 개인정보는 경품 발송 등 이벤트 운영에 필요한 목적으로만 활용되며, 경품 발송 절차 완료 후 관련 기준에 따라 폐기됩니다.",
      "5만원 초과 경품 당첨 시 제세공과금(22%)은 당첨자 본인 부담이며, 제세공과금 처리에 필요한 개인정보 및 고유식별정보 수집·이용 및 제공 동의가 필요합니다.",
      "당첨자가 입력한 개인정보가 정확하지 않아 경품이 오발송 또는 미발송되는 경우 재발송이 불가합니다.",
      "디지털 온누리상품권의 경우 디지털온누리앱에 선물하기를 통해 경품 지급될 예정입니다.",
      "이름과 휴대폰 번호가 디지털온누리앱 가입 정보와 일치한 경우에만 선물을 받을 수 있습니다.",
      "지급된 모바일 쿠폰 이용 시 쿠폰에 기재된 사용기간 및 유의사항을 반드시 확인해 주시기 바랍니다.",
      "발송 완료된 당첨 쿠폰의 분실·도난 등에 대해서는 재발송이 불가합니다. (당첨 쿠폰 복사 및 저장 필수)",
      "본 이벤트는 만 14세 이상 참여 가능하며, 만 14세 미만 참여자의 경우 당첨이 취소될 수 있습니다.",
      "당첨자는 이벤트 종료 후 2026년 12월 중 코그페 누리집 및 코그페 인스타를 통해 발표될 예정입니다.",
      "본 이벤트는 만 14세 이상 참여 가능하며, 만 14세 미만 참여자의 경우 당첨이 취소될 수 있습니다.",
      "이벤트 일정 및 경품 내역은 주최 측 사정에 따라 변경될 수 있으며, 변경 시 코그페 누리집 및 코그페 인스타를 통해 안내될 예정입니다.",
    ],
    eventStart: false,
    mergedTitle: "제품 정보",
    content: ["사과", "바나나", "딸기", "포도"],
  }),
  computed: {
    isShowBtn() {
      return new Date() < new Date("2025-04-13 00:00:00");
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const thisTab = document.querySelector(".tab-button.is-active");
        thisTab.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    });
  },
  methods: {
    clickEvent(e) {
      // let url = 'https://doit5.com/kshoppingfesta/direct?gc=a15';
      let url = "https://doit5.com/kshoppingfesta/list.php";
      const w = 560;
      const h = 600;
      const title = "이벤트";

      // 브라우저 창의 크기 가져오기
      const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

      // 팝업창의 중앙 좌표 계산
      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = height / 2 - h / 2 + dualScreenTop;

      // 팝업창 설정
      const options = `
				scrollbars=yes,
				width=${w},
				height=${h},
				top=${top},
				left=${left},
				status=no,
				menubar=no,
				toolbar=no,
				location=no,
				directories=no,
				copyhistory=no
			`.replace(/\s+/g, "");

      // 팝업창 열기
      const newWindow = window.open(url, title, options);

      // 팝업창이 차단되었는지 확인
      if (window.focus && newWindow) {
        newWindow.focus();
      }

      return newWindow;
    },
    clickLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
